@use '@/styles/tokens' as *;

.form {
  width: 100%;
  padding: var(--space-6);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 32px;
}

.titleGroup {
  display: flex;
  align-items: center;
  gap: 12px;
}

.backBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: inherit;
  border-radius: 4px;
  flex-shrink: 0;

  &:hover {
    background: rgb(0 0 0 / 5%);
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}

.title {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

// Pill shape override for header action buttons.
.pill {
  border-radius: 100px !important;
  padding-inline: 20px !important;
}

.typeRow {
  margin-bottom: var(--space-4);
}

// Form fields constrained to a readable width, left-aligned.
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 20px;
  max-width: 760px;
}

// Description / Specifications span both columns.
.full {
  grid-column: 1 / -1;
}

// Upload zones row — two equal columns, spans full grid width. `minmax(0, 1fr)` keeps a long,
// non-wrapping uploaded file name in the Installation Guide list from blowing its track past
// its content width and squeezing the Device Images column into a sliver (115391).
.uploads {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 18px;
}

.labelWithInfo {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.infoIcon {
  display: inline-flex;
  align-items: center;
  cursor: help;
  color: $color-neutral-500; // palette is SCSS-var only, not a CSS custom prop
}

.moreTag {
  display: inline-flex;
  align-items: center;
  padding: 0 var(--space-2);
  border-radius: var(--radius-sm);
  background: $color-neutral-900; // #1A1A1A
  color: $color-neutral-0; // #FFFFFF
  font-size: 12px;
}

.moreList {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
